import { render, staticRenderFns } from "./deck.vue?vue&type=template&id=243d23fe"
import script from "./deck.vue?vue&type=script&lang=js"
export * from "./deck.vue?vue&type=script&lang=js"
import style0 from "./deck.vue?vue&type=style&index=0&id=243d23fe&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports